import axios from "axios";
import { fetchAuthSession } from "aws-amplify/auth";

export interface WhoAmIResponse {
  id: string;
  email: string;
  name: string;
  role: string;
  createdAt: string;
  updatedAt: string;
}

export const whoami = async (): Promise<WhoAmIResponse> => {
  try {
    const { tokens } = await fetchAuthSession();
    if (!tokens?.idToken) {
      throw new Error("No access token found");
    }
    console.log(tokens.idToken.toString());
    console.log(tokens.accessToken.toString());

    const { data } = await axios.get<WhoAmIResponse>(
      "http://localhost:3001/v1/users/whoami",
      {
        headers: {
          Authorization: `Bearer ${tokens.idToken.toString()}`,
        },
      },
    );
    return data;
  } catch (error) {
    if (error instanceof Error) {
      throw error;
    }
    throw new Error("Failed to authenticate with Cognito");
  }
};

export const whoamiQueryKey = [Math.random()] as const;
